module.exports = __webpack_public_path__ + "static/media/icon-average-high-tide.4472513c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-average-high-tide.svg
// module id = 1339
// module chunks = 0